import { isDevOrLocalEnv } from '../../config';
import { TRANSPARENCY_TYPES } from '../../utils/constants';

const trpDomain = isDevOrLocalEnv(window.location.host)
    ? 'wwwdev.troweprice.com'
    : window.location.host;

const summaryProspectus = {
    name: 'Summary Prospectus',
    link:
        'https://prospectus-express.broadridge.com/summary.asp?doctype=spro&clientid=trowepll&fundid=',
    replaceCusip: true,
    replaceTrpCode: false
};

const prospectus = {
    name: 'Prospectus',
    link:
        'https://prospectus-express.broadridge.com/summary.asp?doctype=pros&clientid=trowepll&fundid=',
    replaceCusip: true,
    replaceTrpCode: false
};

const annualReport = {
    name: 'Annual Shareholder Report',
    link:
        'https://prospectus-express.broadridge.com/summary.asp?doctype=ann&clientid=trowepll&fundid=',
    replaceCusip: true,
    replaceTrpCode: false
};

const semiAnnual = {
    name: 'Semi-Annual Shareholder Report',
    link:
        'https://prospectus-express.broadridge.com/summary.asp?doctype=semi&clientid=trowepll&fundid=',
    replaceCusip: true,
    replaceTrpCode: false
};

const annualFinancialStatements = {
    name: 'Annual Financial Statements',
    link:
        'https://prospectus-express.broadridge.com/summary.asp?doctype=lann&clientid=trowepll&fundid=',
    replaceCusip: true,
    replaceTrpCode: false
};

const semiAnnualFinancialStatements = {
    name: 'Semi-Annual Financial Statements',
    link:
        'https://prospectus-express.broadridge.com/summary.asp?doctype=lsem&clientid=trowepll&fundid=',
    replaceCusip: true,
    replaceTrpCode: false
};

const proxyVotingRecord = {
    name: 'Proxy Voting Record',
    link:
        'https://prospectus-express.broadridge.com/summary.asp?doctype=pxvc&clientid=trowepll&fundid=',
    replaceCusip: true,
    replaceTrpCode: false
};

const additionalInfo = {
    name: 'Statement of Additional Information (SAI)',
    link:
        'https://prospectus-express.broadridge.com/summary.asp?doctype=sai&clientid=trowepll&fundid=',
    replaceCusip: true,
    replaceTrpCode: false
};

const etfFactSheet = {
    name: 'Quarterly Fact Sheet',
    link: `https://${trpDomain}/literature/public/country/us/language/en/literature-type/quarterly-factsheet/sub-type/etf-single-class?productCode=TRPCODE`,
    replaceCusip: false,
    replaceTrpCode: true
};

const etfPortfolioHoldings = {
    name: 'Quarterly Portfolio Holdings',
    link: `https://${trpDomain}/personal-investing/funds/etfs/prospectuses-reports/portfolio-holdings.html`,
    replaceCusip: false,
    replaceTrpCode: false
};

const links = [
    summaryProspectus,
    prospectus,
    annualReport,
    semiAnnual,
    annualFinancialStatements,
    semiAnnualFinancialStatements,
    proxyVotingRecord,
    additionalInfo,
    {
        name: 'Quarterly Fact Sheet',
        link: `https://${trpDomain}/literature/public/country/us/language/en/literature-type/quarterly-factsheet/sub-type/mf-single-class?productCode=TRPCODE`,
        replaceCusip: false,
        replaceTrpCode: true
    },
    {
        name: 'Monthly Portfolio Holdings',
        link: `https://${trpDomain}/personal-investing/funds/mutual-funds/prospectuses-reports/money-funds-monthly-portfolio-holdings.html`,
        replaceCusip: false,
        replaceTrpCode: false,
        moneyMarket: true
    },
    {
        name: 'Quarterly Portfolio Holdings',
        link: `https://${trpDomain}/personal-investing/funds/mutual-funds/prospectuses-reports/portfolio-holdings.html`,
        replaceCusip: false,
        replaceTrpCode: false,
        moneyMarket: false
    },
    {
        name: 'Year-end Tax Considerations',
        link: `https://${trpDomain}/personal-investing/resources/planning/tax/index.html`,
        replaceCusip: false,
        replaceTrpCode: false
    },
    {
        name: 'Year-end Dividend Distributions',
        link: `https://${trpDomain}/personal-investing/resources/planning/tax/dividend-distributions/mutual-funds/index.html`,
        replaceCusip: false,
        replaceTrpCode: false
    }
];

const linksFullyTranparent = [
    summaryProspectus,
    prospectus,
    annualReport,
    semiAnnual,
    annualFinancialStatements,
    semiAnnualFinancialStatements,
    proxyVotingRecord,
    additionalInfo,
    etfFactSheet
];

const linksETF = [
    summaryProspectus,
    prospectus,
    annualReport,
    semiAnnual,
    annualFinancialStatements,
    semiAnnualFinancialStatements,
    proxyVotingRecord,
    additionalInfo,
    etfFactSheet,
    etfPortfolioHoldings,
    {
        name: 'Proxy Portfolio and Custom Baskets',
        link: `https://${trpDomain}/financial-intermediary/us/en/investments/exchange-traded-funds/blue-chip-growth-etf.html#primary-holdings,no-description-provided-portfolio-tracking`,
        replaceCusip: false,
        replaceTrpCode: false,
        replaceFundName: true
    }
];

export const getLinks = (etf, transparencyType, moneyMarket) => {
    if (etf && transparencyType === TRANSPARENCY_TYPES.FULL) {
        return linksFullyTranparent;
    }

    if (etf) {
        return linksETF;
    }

    return links.filter(
        (link) =>
            link.moneyMarket === undefined || link.moneyMarket === moneyMarket
    );
};
